// dashboard/frontend/src/api/axios.js
import axios from 'axios';

const api = axios.create({
    baseURL: '/api',
    withCredentials: true,
    xsrfCookieName: 'csrftoken',
    xsrfHeaderName: 'X-CSRFToken',
});

// Add interceptor to handle CSRF token
api.interceptors.request.use(config => {
    const csrfToken = document.cookie
        .split('; ')
        .find(row => row.startsWith('csrftoken='))
        ?.split('=')[1];
        
    if (csrfToken) {
        config.headers['X-CSRFToken'] = csrfToken;
    }
    return config;
});

// Add response interceptor for error handling
api.interceptors.response.use(
    response => response,
    error => {
        if (error.response?.status === 403) {
            // Handle CSRF errors
            console.error('CSRF token error:', error);
        } else if (error.response?.status === 401) {
            // Handle authentication errors
            console.error('Authentication error:', error);
            // Optionally redirect to login
            window.location.href = '/auth/login';
        }
        return Promise.reject(error);
    }
);

export default api;